/* eslint-disable react/prop-types */
import React from 'react';

//==================Externals==================//
import classNames from 'classnames';
import PropTypes from 'prop-types';

//==================Styles==================//
import { Search } from '@mui/icons-material';
import { Input } from '@mui/material';
import styles from './styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(styles);

const SearchInput = (props) => {
  //==================Variables==================//
  const { className, onChange, style, ...rest } = props;
  const classes = useStyles();
  const rootClassName = classNames(classes.root, className);

  return (
    <div className={rootClassName} style={style}>
      <Search className={classes.icon} />
      <Input
        {...rest}
        className={classes.input}
        disableUnderline={true}
        onChange={onChange}
      />
    </div>
  );
};

//==================PropTypes==================//
SearchInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  style: PropTypes.object,
};

SearchInput.defaultProps = {
  onChange: () => {},
};

export default SearchInput;
